import { ReactElement } from 'react';

import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import {
   Modal,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   StyledFlex,
   TextView,
} from '@dreryk/react-components';
import { dateTimeMinuteFormatter, patientNameFormatter, practitionerNameFormatter } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../translations';

import { ConfidentialResourcesTable } from './table/ConfidentialResourcesTable';

type ConfidentialResourcesModalProps = {
   request: ConfidentialResourceAccessRequest;
   onClose: VoidFunction;
};

export const ConfidentialResourcesModal = (props: ConfidentialResourcesModalProps): ReactElement => {
   const { request, onClose } = props;

   return (
      <Modal
         title={systemActivityTranslationKeys.confidentialResourcesListTitle}
         onCloseRequest={onClose}
         width={ModalWidth.WIDE}
         testId={'confidentialResourcesModal'}
         visible
      >
         <StyledFlex direction={'column'} gap={'16px'}>
            <StyledFlex gap={'32px'}>
               <TextView testId={'grantee'} label={systemActivityTranslationKeys.requestingPractitioner}>
                  {practitionerNameFormatter(request.grantee)}
               </TextView>
               <TextView testId={'patient'} label={systemActivityTranslationKeys.patient}>
                  {patientNameFormatter(request.patient)}
               </TextView>
               <TextView testId={'accessGrantedAt'} label={systemActivityTranslationKeys.accessGrantedDate}>
                  {request.decisionDate ? dateTimeMinuteFormatter(request.decisionDate) : null}
               </TextView>
            </StyledFlex>

            <ConfidentialResourcesTable resources={request.confidentialResources} />

            <ModalConfirmButton label={systemActivityTranslationKeys.close} onClick={onClose} />
            <ModalCloseButton onClick={onClose} />
         </StyledFlex>
      </Modal>
   );
};
